var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name === 'projectDataSetsCreate')?_c('DataSetsCreate'):(_vm.$route.name === 'projectDataSetsDetails')?_c('DataSetsDetails'):(_vm.$route.name === 'projectDataSetsEditor')?_c('DataSetsEditor'):_c('DataSetsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }